// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__wVQOQ","white_btn":"styles_white_btn__KNasw"};